import { Divider } from 'components/ui';
import { AuthDividerProps } from './AuthDivider.props';
import { AuthDividerRoot } from './AuthDivider.styles';

const AuthDivider = ({ sx, ...props }: AuthDividerProps) => (
  <AuthDividerRoot>
    <Divider sx={sx} visualVariant="labeledAccent" {...props} />
  </AuthDividerRoot>
);

export default AuthDivider;
